import { render, staticRenderFns } from "./UserCount.vue?vue&type=template&id=bfa0ee64&"
import script from "./UserCount.vue?vue&type=script&lang=js&"
export * from "./UserCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports